import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone, faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';

const Hero = () => {
  return (
    <section className="bg-white py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
          Professional Auto Repair
          <span className="block text-primary mt-2">You Can Trust</span>
        </h2>
        <p className="text-xl text-gray-600 mb-12 max-w-3xl mx-auto">
          At Sharp Deal Auto Repair Inc., you can trust our automotive services with your car.
          With over 25 years of experience, your reliable auto repair shop is here to help.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12">
          <a
            href="#contact"
            className="bg-primary text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-secondary transition-colors w-full sm:w-auto text-center"
          >
            Book Appointment
          </a>
          <a
            href="tel:3058210101"
            className="border-2 border-primary text-primary px-8 py-4 rounded-lg font-semibold text-lg hover:bg-primary hover:text-white transition-colors flex items-center justify-center w-full sm:w-auto text-center"
          >
            <FontAwesomeIcon icon={faPhone} className="mr-2" />
            Call Now
          </a>
        </div>

        <div className="flex justify-center space-x-8 text-sm text-gray-500">
          <div className="flex items-center space-x-2">
            <FontAwesomeIcon icon={faPhone} className="text-primary" />
            <span>(305) 821-0101</span>
          </div>
          <div className="flex items-center space-x-2">
            <FontAwesomeIcon icon={faMapMarkerAlt} className="text-primary" />
            <span>1730 W 31st Pl, Hialeah, FL 33012</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;